export enum BookingLocationType {
  STATION = 'STATION',
  STREET = 'STREET',
}
